import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

import { AssetPathPipe, CssUtils, DirectionService } from '@hdms/shared/util-core';

export const SizeOption = {
  SMALL: 'small',
  LARGE: 'large',
  RESPONSIVE: 'responsive',
  NONE: 'none'
} as const;

export type SizeOptionType = (typeof SizeOption)[keyof typeof SizeOption];

@Component({
  selector: 'shrd-uic-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgIconComponent implements OnChanges {
  static spritePath: string;

  rtl = false;
  spriteUrl: string;
  iconWidth: string;
  iconHeight: string;
  isResponsive: boolean;
  applyIconSizeModification: boolean;

  @Input() title: string;
  @Input() icon: string;
  @Input() iconClasses = '';
  @Input() preventRtlSwap = false;
  @Input() inheritColor = false;
  @Input() size: SizeOptionType = SizeOption.RESPONSIVE;

  @Input()
  set width(value: string | number) {
    this.iconWidth = CssUtils.pxToRem(value);
  }

  @Input()
  set height(value: string | number) {
    this.iconHeight = CssUtils.pxToRem(value);
  }

  @HostBinding('class.shrd-uic-svg-icon') baseClass = true;
  @HostBinding('class.svg-icon-border')
  @Input()
  hasBorder = false;

  constructor(private readonly assetPathPipe: AssetPathPipe, private readonly directionService: DirectionService) {
    SvgIconComponent.spritePath ??= this.assetPathPipe.transform(`/assets/sprites/sprite.symbol`);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.icon || changes.size || changes.preventRtlSwap) {
      this.rtl = this.directionService.isRtl && !this.preventRtlSwap;
      this.isResponsive = this.size === SizeOption.RESPONSIVE;

      this.setSpriteUrl();
    }
  }

  private setSpriteUrl(): void {
    this.applyIconSizeModification = this.size === SizeOption.SMALL || this.size === SizeOption.RESPONSIVE;
    this.spriteUrl = this.generateSpriteSymbolUrl();
  }

  private generateSpriteSymbolUrl(): string {
    return `${SvgIconComponent.spritePath}${this.rtl ? '.rtl' : ''}.svg#${this.icon}`;
  }
}
